<template>
  <div>
    <h1>123</h1>
  </div>
</template>

<script>
export default {
  name: 'TokenLieBiaoPage',
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  mounted() {
    
  },
};
</script>

<style scoped>

</style>



